var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLike = function SvgLike(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54.004,
    viewBox: "0 0 54 54.004",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component_5_1",
    "data-name": "Component 5 \\u2013 1",
    transform: "translate(2 2.004)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_82",
    "data-name": "Line 82",
    y1: 0.01,
    transform: "translate(47.554 33.772)",
    fill: "none",
    stroke: "#2699fb",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1049",
    "data-name": "Path 1049",
    d: "M916.5,802.757c7.756-1.763,15.53-10.853,15.53-21.686,0-2.7,5.631-3.068,7.1,1.927,1.664,5.641-1.014,10.594-3.044,15.409h10.148",
    transform: "translate(-900.3 -779.12)",
    fill: "none",
    stroke: "#2699fb",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1050",
    "data-name": "Path 1050",
    d: "M946.241,798.407a3.96,3.96,0,0,1,4.059,3.853h0a3.959,3.959,0,0,1-4.059,3.852h-1.015",
    transform: "translate(-900.3 -779.12)",
    fill: "none",
    stroke: "#2699fb",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1051",
    "data-name": "Path 1051",
    d: "M945.226,806.112a3.96,3.96,0,0,1,4.059,3.853h0a3.959,3.959,0,0,1-4.059,3.852h-1.015",
    transform: "translate(-900.3 -779.12)",
    fill: "none",
    stroke: "#2699fb",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1052",
    "data-name": "Path 1052",
    d: "M943.2,813.817a3.96,3.96,0,0,1,4.059,3.853h0a3.96,3.96,0,0,1-4.059,3.852h-1.016",
    transform: "translate(-900.3 -779.12)",
    fill: "none",
    stroke: "#2699fb",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1053",
    "data-name": "Path 1053",
    d: "M945.226,806.112a3.96,3.96,0,0,1,4.059,3.853h0a3.959,3.959,0,0,1-4.059,3.852H943.2",
    transform: "translate(-900.3 -779.12)",
    fill: "none",
    stroke: "#2699fb",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1054",
    "data-name": "Path 1054",
    d: "M942.182,828.264h-14.2c-4.066,0-11.478-3.537-11.478-3.537",
    transform: "translate(-900.3 -779.12)",
    fill: "none",
    stroke: "#2699fb",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1055",
    "data-name": "Path 1055",
    d: "M941.167,821.522h.507a3.465,3.465,0,0,1,3.552,3.371h0a3.465,3.465,0,0,1-3.552,3.371h-1.522",
    transform: "translate(-900.3 -779.12)",
    fill: "none",
    stroke: "#2699fb",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1109",
    "data-name": "Rectangle 1109",
    width: 16.204,
    height: 30.757,
    rx: 1,
    transform: "translate(0 19.243)",
    strokeWidth: 4,
    stroke: "#2699fb",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  }))));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLike, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/like.f0ba53cf.svg";
export { ForwardRef as ReactComponent };